import React, { useCallback } from "react";
import { Button } from "antd";
const DealerInvoiceLinkButton = ({ invoiceId }) => {
    const handleOnClick = useCallback(() => {
        window.open(`${REACT_APP_INVOICE_URL}?txnId=${invoiceId}`);
    }, [invoiceId]);
    return (React.createElement(Button, { type: "primary", onClick: handleOnClick, disabled: !invoiceId }, "View on Quickbooks"));
};
export default DealerInvoiceLinkButton;
